import { NavegacionProductos } from '../../components';

const FrijolesRefritosBajosEnGrasa = () => {
    return <NavegacionProductos />;
};

export default FrijolesRefritosBajosEnGrasa;
